import React, { forwardRef, type HTMLAttributes } from 'react';
import styles from './CommentableSelectQuestion.scss';

type Props = React.DetailedHTMLProps<
  HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>;

export const CommentableSelectQuestionContainer = forwardRef<
  HTMLDivElement,
  Props
>(({ children, ...otherProps }, ref) => (
  <div className={styles.container} ref={ref} {...otherProps}>
    {children}
  </div>
));
